import { api } from "../client";

export const logOffVDI = () => {
  return api.delete(`/selfservice/vdi/logoff`);
};
